import "./App.css";
import "./i18n";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";

import { Security, LoginCallback, useOktaAuth } from "@okta/okta-react";
// import { OktaAuth } from "@okta/okta-auth-js";

import store from "./Redux/store";
import Login from "./auth/login";
import LogoutPage from "./auth/logout";
import LoginCallBack from "./auth/LoginCallBack";
import { FontSizeProvider } from "./common/fontSizeContext";
import { toRelativeUrl } from "@okta/okta-auth-js";
import oktaAuthInstance from "./oktaAuth.ts";
// import httpInterceptor from "./Interceptor/http-interceptor";
import React, { useContext, useEffect,useLayoutEffect, useRef, useState,Suspense, lazy } from "react";
import HeaderView from "./common/header-view";
// import i18n from "./common/i18n";
// import { ThemeProvider } from "./common/themeContext";
import { ThemeProvider } from "pepsico-ds";
import "pepsico-ds/css";
import { MenuProvider } from "./common/menuContext";
import SidebarView from "./common/sidebar";
import PrivateRoute from "./auth/private_route";
import HomeView from "./Components/landing/home-view.jsx";
import ManageAccounts from "./Components/manage_accounts/employee_request/manage_accounts";
import Footer from "./common/footer";
import {
  UserProfileProvider,
  UserProfileContext,
} from "./common/user_profile_context.jsx";
import { useTranslation } from "react-i18next";
import Approvals from "./Components/workflow/approvals.jsx";
import WorkflowApproval from "./Components/workflow/WorkflowApproval.jsx";
// import ReCAPTCHA from "./ReCAPTCHA.js";
import ChangePassword from "./auth/change_password.jsx";
import { Button, Icon, LoadingSpinner, Modal } from "pepsico-ds";
import { LoadingProvider, useLoading  } from "./loader.jsx";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PowerBIReport from "./Components/workflow/power_bi_reports.jsx";
import ChartsView from "./Components/landing/pki_certificate_charts.jsx";
import PowerBIEmbeddedReport from "./Components/workflow/power_bi_embedded_report.jsx";
import ChatBotWidget from "./common/GIA Chat Agent/chat_bot.jsx";
import MyidmView from "./Components/landing/myidm-view.jsx";
import SearchRequestsView from "./Components/landing/search_request_view.tsx";
import RequestNewAccessForSelf from "./Components/requests/request_new_access_for_self.tsx";
import RequestNewAccessForOthers from "./Components/Request_New_Access_For_Others/request_new_access_for_others.jsx";
import { useInactivityHandler } from "./inactivity-timer.jsx";
import oktaAuth from "./oktaAuth.ts";
import MyidmView1 from "./Components/landing/myidm-view1.jsx";
import UpdateProfile from "./Components/manage_accounts/update_profile/update-profile.jsx";
import BulkRevalidation from "./Components/manager_other_accounts/bulk-revalidation.jsx";
import SingleExtensionReactivation from "./Components/manager_other_accounts/single-extension_reactivation.jsx";
import ExtensionRequest from "./Components/manager_other_accounts/extension_request.jsx";
import AuditPendingRequests from "./Components/Audit_Request/audit-pending-requests.jsx";
import Joyride, { EVENTS, STATUS, ACTIONS } from "react-joyride"; 
import { useNavigate } from 'react-router-dom';
import OtherRequestList from "./Components/Audit_Request/others-request-list.jsx";
import OtherUsersProfileSearch from "./Components/manager_other_accounts/other_users_profile_search.jsx";
import Outage from "./common/outage.jsx";
import { SessionTimeoutProvider } from './Interceptor/SessionTimeoutContext.tsx'
import SvcAccountRequest from './Components/pam/svc_account_request.jsx'
import { useHttpInterceptor } from './Interceptor/interceptor.ts'
import SessionTimeoutModal from './Interceptor/SessionTimeoutModal.tsx'
import SvcAccountRequestApproval from "./Components/pam/svc_account_request_approval.jsx";
import { REACT_APP_VERSION_CONSTANT } from "./utils/constant.js";
import PendingAuditRequests from "./Components/Audit_Request/pending-audit-requests.jsx";
import SSOOnboarding from "./Components/sso/sso_onboarding";
import SSOModification from "./Components/sso/sso_modification";
import SSOOnboardingDetails from "./Components/sso/sso_onboarding_details";
import SSOModificationDetails from "./Components/sso/sso_modification_details";
import ActiveDirectory from "./Components/active_directory/active-directory.jsx";
import EntraGuestInvitationRequest from "./Components/entra_guest/entra-guest-invitation-request.jsx";
import GuestManagement from "./Components/entra_guest/guest-management.jsx";
import PamSafeCreateUpdate from "./Components/pam/PamSafeCreateUpdate.jsx";
import PamSafeAccessRequest from "./Components/pam/PamSafeAccessRequest.jsx";
import IdxAttributeBulkLoad from "./Components/idx/idxAttributeBulkLoad.jsx";
import IdxReportingSelfService from "./Components/idx/idxReportingSelfService.jsx";
import IrIncidentResponse from "./Components/ir_incident_response/irIncidentResponse.jsx"
import OtherActiveDirectory from "./Components/active_directory/others-active-directory.jsx";
import IdxTestIdRequestPreProd from "./Components/idx/idxTestIdRequestPreProd.jsx";
import IdxPreProdGroupMembership from "./Components/idx/idxPreProdGroupMembership.jsx";
import IdxPreProdApplicationAccess from "./Components/idx/IdxPreProdAccessRequest.jsx";
import IdxPasswordReset from "./Components/idx/IdxPasswordReset.jsx";
import AppRetirement from "./Components/app_retirement/app-retirement.jsx";
import AppRegisteration from "./Components/app_registeration/app-registeration.jsx";

const ChatBot = lazy(() => import("./common/GIA Chat Agent/functional_chat_bot.jsx"));
// import ChatBot from "./common/chatbot.jsx";


// httpInterceptor.httpinterceptor(store);

// Disable console logs in production environment
// Uses REACT_APP_NAME to determine environment (PROD, QA, DEV, etc.)
if (process.env.REACT_APP_NAME === 'PROD') {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
}

const MenuDependentContent = () => {
  const { REACT_APP_POST_REDIRECT_URI, REACT_APP_VERSION } = process.env;
  // const { oktaAuth } = useOktaAuth();
  const [countdown, setCountdown] = useState(60);
  const { userProfile } = useContext(UserProfileContext);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isAuthenticated, setIsAuthenticated] = React.useState(null);
  const [loading, setLoading] = useState(true);
  const { showLoader, hideLoader } = useLoading();
  const [mobileMenu, setMobileMenu] = useState(false);
  const [isManager, setIsManager] = useState(false);
  const { t, i18n } = useTranslation();
  const sidebarRef = useRef(null);
  const headerRef = useRef(null);
  const [showChatBot, setShowChatBot] = useState(false);
  const [showTimeoutDialog, setShowTimeoutDialog] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    document.body.setAttribute("data-route", location.pathname);
  }, [location.pathname]);

  const autoLogout = () =>{
    showLoader()
    const storedVersion = localStorage.getItem("app_version");
    localStorage.clear();
    localStorage.setItem("logout", "true");
    localStorage.setItem("app_version", storedVersion || "");
    const date = new Date();
    date.setTime(date.getTime() + 60 * 60 * 1000);
    const expires = "expires=" + date.toUTCString();
    document.cookie = "logout= true;" + expires + ";path=/";
    setTimeout(async() => {
        try{
          await oktaAuth.signOut({
            postLogoutRedirectUri: REACT_APP_OKTA_POST_LOGOUT_REDIRECTURI,
          });
        }finally{
          setTimeout(()=>hideLoader(),1000)
        }
    }, 100);
  }

  // Inactivity handling
  // const { resetTimer } = useInactivityHandler(55 * 60 * 1000, () => {
  //   console.log("User is inactive. Logging out...");
  //   if (window.location.pathname.includes("/public")) {
  //     autoLogout();
  //     return;
  //   }
  //   setShowTimeoutDialog(true);
  //   const logoutExpiry = localStorage.getItem("logoutExpiry"); 
  //   if(!logoutExpiry){
  //     const expiry = Date.now() + 60 * 1000;
  //     localStorage.setItem("logoutExpiry", expiry);
  //   }
  // });


const { resetTimer } = useInactivityHandler(55 * 60 * 1000, () => {
  const now = Date.now();
  const lastActivity = parseInt(localStorage.getItem("lastActivity") || now, 10);
  const elapsed = now - lastActivity;
  if (elapsed >= ((55 * 60 * 1000) +(1 * 60 * 1000))) {
    console.log("User inactive too long. Auto-logging out...");
    autoLogout();
    return;
  }
  setShowTimeoutDialog(true);
  const logoutExpiry = localStorage.getItem("logoutExpiry");
  if (!logoutExpiry) {
    const expiry = Date.now() + 60 * 1000;
    localStorage.setItem("logoutExpiry", expiry.toString());
  }
});
  useEffect(()=>{
    if(userProfile?.isFirstTimeLogin){
      console.log('first time login',userProfile?.isFirstTimeLogin);
      
      startTour();
    }
  },[userProfile?.isFirstTimeLogin])

  useEffect(() => { 
    const handleVisibility = () => { 
      const expiry = localStorage.getItem("logoutExpiry"); 
      if (expiry && Date.now() >= expiry) { 
        localStorage.removeItem("logoutExpiry");
        autoLogout();  
      } 
    }; 
    document.addEventListener("visibilitychange", handleVisibility); 

    const id = setInterval(()=>{
      const currentVersion = REACT_APP_VERSION_CONSTANT || "1";
      const storedVersion = localStorage.getItem("app_version");
       
      if (storedVersion !== currentVersion) { 
        localStorage.setItem("app_version", currentVersion); 
        window.location.reload()
      } 
    }, 60000);
    
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", handleVisibility); 
    }
  }, []);

  useEffect(() => {
    let timer;
    if (showTimeoutDialog) {
      timer = setInterval(() => {
        const expiry = localStorage.getItem("logoutExpiry"); 
        if (!expiry) return;
        const diff = Math.floor((expiry - Date.now()) / 1000); 
        if (diff <= 0) { 
          clearInterval(timer); 
          localStorage.removeItem("logoutExpiry");
          autoLogout(); 
        } else { 
          setCountdown(diff); 
        }

        // setCountdown((prev) => {
        //   if (prev <= 1) {
        //     handleLogout();
        //     return 0;
        //   }
        //   return prev - 1;
        // });
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [showTimeoutDialog]);
  
  // const handleLogout = () => {
  //   localStorage.setItem("logout", true);
  //   const date = new Date();
  //   date.setTime(date.getTime() + 55 * 60 * 1000);
  //   const expires = "expires=" + date.toUTCString();
  //   document.cookie = "logout= true;" + expires + ";path=/";
  //   oktaAuth.signOut({
  //     postLogoutRedirectUri: window.location.origin + '/login',
  //   });
  // };

  const handleLogout = () => {
    localStorage.setItem("okta-force-logout", Date.now());
    oktaAuth.signOut({
      postLogoutRedirectUri: "https://secure.ite.pepsico.com/login/signout"
    });
  };

  useEffect(() => {
    const logoutHandler = () => {
      oktaAuth.tokenManager.clear();

      window.location.href = "https://secure.ite.pepsico.com/login/signout";
    };

    const listener = (event) => {
      if (event.key === "okta-force-logout") {
        logoutHandler();
      }
    };

    window.addEventListener("storage", listener);
    return () => window.removeEventListener("storage", listener);
  }, []);

  const handleStayLoggedIn = async () => {
    setShowTimeoutDialog(false);
    resetTimer();

  };

  const closeModal = () => {
    setShowTimeoutDialog(false);
    resetTimer();
  };

  const {
    REACT_APP_API_ENDPOINT,
    REACT_APP_CONST,
    REACT_APP_OKTA_POST_LOGOUT_REDIRECTURI,
    REACT_APP_OKTA_HOST_URL
  } = process.env;
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    // similar behavior as clicking on a link
    const userAuthenticated = JSON.parse(
      localStorage.getItem("okta-token-storage")
    )?.accessToken?.accessToken;

    if (userAuthenticated || window.location.hostname.includes("localhost")) {
      setIsAuthenticated(true); // Set logged-in status based on token presence
    } else {
      setIsAuthenticated(false);
    }
    // hideLoader();
    setLoading(false);
  }, []);

  const showMenu = (val) => {
    setMobileMenu(val);
  };

  useEffect(() => {
    const isRtl = i18n.language?.split("_")?.[0] === "ar";
    // console.log("isRtl", isRtl);
    // console.log("i18n.language", i18n.language);
    // console.log("Logout url- Dynamic", REACT_APP_OKTA_POST_LOGOUT_REDIRECTURI);
    document.body.classList.toggle("rtl", isRtl);
    document.body.setAttribute("data-lang", i18n.language?.split("_")?.[0]);
    // document.documentElement.lang = i18n.language;
    const dummy = document.body.offsetHeight;
    const observer = new MutationObserver(() => {
      const targetElement = document.querySelector(".page-wrapper");
      if (targetElement) {
        targetElement.style.direction = isRtl ? "rtl" : "ltr";
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    i18n.on("languageChanged", () => {
      const targetElement = document.querySelector(".page-wrapper");
      if (targetElement) {
        targetElement.style.direction =
          i18n.language?.split("_")?.[0] === "ar" ? "rtl" : "ltr";
      }
    });

    return () => {
      observer.disconnect();
    };
  }, [i18n.language]);

  const toggleChatBot = () => {
    setShowChatBot((prev) => !prev);
  };
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Joyride: single instance here

  const [runTour, setRunTour] = useState(false); 
  const [stepIndex, setStepIndex] = useState(0);
  const [joyrideKey, setJoyrideKey] = useState(0);
  const [gpid,setGpid] = useState('');

  // Define steps for each page. Ensure targets exist in those components.
  const steps = [ 
    { target: ".sectionHeaderQuickLinks", content: "IAM Central is one stop destination for all IAM service to enhance user experience with PepsiCo UI standards and simply access to all IAM service like myidM, SSO, pepAGM , Directory , PKI etc. It is enabled with AI capabilities to offer. ",disableBeacon: true}, // 0
    { target: "#tab-myidM", content: "Quick links for myidM services where you can Change Password, Raise a New/Modify for self or others and track your submitted Request status  etc." }, // 1
    { target: "#tab-SSO", content: "Quick links for SSO services where you can App onboarding and Update MFA Factors etc." },// 2
    { target: "#tab-pepAGM", content: "Quick links for pepAGM services where you can Access the application and help resources etc." }, // 3
    { target: "#tab-PKI", content: "Quick links for PKI services where you can Access the application, Certificate Requests, help resources and Certificate Expiry Dashboard Summary/Insights etc." }, // 4
    { target: "#tab-myPAM", content: "Quick links for myPAM services where you can Access the application etc." },// 5
    { target: "#tab-DS", content: "Quick links for Directory services where you can Access the IDX Test account reset and myITS Service Requests etc." },// 6
    { target: "#tab-CIAM", content: "Quick links for CIAM where you can submit a request for CIAM and Onboard a new partner for CIAM etc." },// 7
    
    { target: "#card-myidM-change_password", content: "You can change password here" }, // 8
    { target: "#change_password_container", content: "Set your password and submit." },// 9
    { target: "#card-myidM-request_access", content: "You can Raise a new request for self from here" }, // 10
    // { target: "#search-requests", content: "List of current access shown in the list and you can raise a new request using new request button" }, // 11
    { target: ".approvalCard", content: "You can approve/reject all your pending requests." },// 11
    // {target:"#pendingApprovals",content:"You can approve/reject request, click on view more get more details."},// 13
    // {target:"#card-myidM-approve_idm",content:"Track your submitted request status here"},// 12
    {target:".view-request-ref",content:"You can Track your submitted request status by GPID,E Mail,Firstname, Last Name etc.."},//12
    // {target:".requests-container",content:"Here you can review all your submitted requests and take appropriate actions, such as sending reminders or canceling requests etc."},//16
    {target:".req-new-access-self-ref",content:"You can raise a new request for self here"},//13
    {target:".req-mod-access-self-ref",content:"You can raise a modify/disable request for self here"},//14    
    {target:".request-access-others-ref",content:"You can raise a new request for others here"},//15
    {target:".request-access-others-mod-ref",content:"You can raise a modify/disable request for others here"},//16
    {target:".update-profile-ref",content:"You can update your profile from here"},//17
    // {target:".update-profile-email-ref",content:"You can Validate Phone and Non-Pepsico Email using OTP"},//22
    {target:".change-password-ref",content:"You can do the Change Password from here"},//18
    {target:".exe-react-ref",content:"You can do the Extension/Reactivation here"},//19
    {target:"#chatbot",content:"This is AI Agent, you can chat and get the the desired answers."},//20
    // {target:".extension-content-wrapper",content:"You can do the Extension/Reactivation for your contractors after submitting new expiration date"},//24 
  ];  

  
  // Rehydrate step index when data is available or route changes
  useEffect(() => {
    if (!loading && userProfile) { 
      const saved = localStorage.getItem("tourStepIndex");
      if (saved !== null) {
        const parsed = parseInt(saved, 10);
        if (!Number.isNaN(parsed)) {
          setStepIndex(parsed);
        }
      } else {
        localStorage.setItem("tourStepIndex", "0");
        setStepIndex(0);
      }
      // setRunTour(true);
    }
  }, [loading, userProfile]);
  const data = JSON.parse(localStorage.getItem("okta-token-storage") ?? "{}");
  useEffect(() => {
    if (!gpid && data?.accessToken?.claims?.gpid) {
      setGpid(data?.accessToken?.claims?.gpid);
    }
  
  }, [gpid]);
const handleJoyrideCallback = (data) => {
  const { action, index, status, type } = data;
  console.log('212121212',action, index, status, type);
  
  // Handle finish/skip
  if (action === 'close' || status === STATUS.FINISHED || status === STATUS.SKIPPED || (index === steps.length - 1 && type === EVENTS.STEP_AFTER)) {
    setRunTour(false);
    localStorage.removeItem("tourStepIndex");
    setJoyrideKey(prev => prev + 1);
    navigate('/home')
    return;
  } 

  // Only react after Joyride finishes a step transition
  if (type === EVENTS.STEP_AFTER) {
    const delta =
      action === ACTIONS.NEXT ? 1 :
      action === ACTIONS.PREV ? -1 : 0;
    const nextIndex = Math.max(0, Math.min(steps.length - 1, index + delta));

    // Persist and advance the controlled index
    localStorage.setItem("tourStepIndex", String(nextIndex));
    setStepIndex(nextIndex); 
    const target = steps[nextIndex].target;
    const tabMap = { 
      "#tab-myidM": 0,
      "#tab-SSO": 1,
      "#tab-pepAGM": 2,
      "#tab-PKI": 3,
      "#tab-myPAM": 4,
      "#tab-DS": 5,
      "#tab-CIAM": 6,
    };
       
    if (tabMap[target] !== undefined) {
      window.dispatchEvent(new CustomEvent('switchTab', { detail: tabMap[target] }));
      setRunTour(false);
      setTimeout(() => setRunTour(true), 300);
    }
    
    if (nextIndex === 8) {
      window.dispatchEvent(new CustomEvent("switchTab", { detail: 0 })); // myidM tab
      setRunTour(false);
      setTimeout(() => setRunTour(true), 300);
    }

    // Route per next step (not the current one)
    if ([0,8,10,11].includes(nextIndex) && location.pathname !== "/home") {
      setRunTour(false);          // pause while navigating
      navigate("/home");
      setTimeout(() => setRunTour(true), 300); // resume after DOM loads
    } else if (nextIndex === 9 && location.pathname !== "/change-password") {
      setRunTour(false);
      navigate("/change-password");
      setTimeout(() => setRunTour(true), 300);
    } 
    // else if (nextIndex === 11 && location.pathname !== "/request-access") {
    //   setRunTour(false);
    //   navigate("/request-access"); 
    //   setTimeout(() => setRunTour(true), 300); 
    // }
    // else if (nextIndex === 13 && location.pathname !== "/approvals") {
    //   setRunTour(false);
    //   navigate("/approvals"); 
    //   setTimeout(() => setRunTour(true), 300);
    // }
    else if (nextIndex === 12 && location.pathname !== "/myidmPortal") {
      setRunTour(false);
      let statePayload = { navigateFrom: "extension_request"};
      navigate("/myidmPortal", { state: statePayload });
      setTimeout(() => setRunTour(true), 300);
    }
    // else if (nextIndex === 16 && location.pathname !== "/audit-requests") {
    //   setRunTour(false);
    //   let statePayload = { navigateFrom: "extension_request"};
    //   statePayload = { type: "gpid", value:gpid };
    //   navigate("/audit-requests", { state: statePayload });
    //   setTimeout(() => setRunTour(true), 300);
    // }
    else if ([13].includes(nextIndex) && location.pathname !== "/myidmPortal") {
      setRunTour(false);          // pause while navigating
      navigate("/myidmPortal");
      setTimeout(() => setRunTour(true), 300); // resume after DOM loads
    }else if ([14].includes(nextIndex) && location.pathname !== "/myidmPortal") {
      setRunTour(false);          // pause while navigating
      navigate("/myidmPortal");
      setTimeout(() => setRunTour(true), 300); // resume after DOM loads
    }else if ([15].includes(nextIndex) && location.pathname !== "/myidmPortal") {
      setRunTour(false);          // pause while navigating
      navigate('/myidmPortal', { state: {navigateFrom: 'request_access_others'} })
      setTimeout(() => setRunTour(true), 300); // resume after DOM loads
    }else if ([16].includes(nextIndex) && location.pathname !== "/myidmPortal") {
      setRunTour(false);          // pause while navigating
      navigate("/myidmPortal");
      setTimeout(() => setRunTour(true), 300); // resume after DOM loads
    }else if ([17].includes(nextIndex) && location.pathname !== "/myidmPortal") {
      setRunTour(false);          // pause while navigating
      navigate("/myidmPortal");
      setTimeout(() => setRunTour(true), 300); // resume after DOM loads
    }
    // else if ([22].includes(nextIndex) && location.pathname !== "/myidmPortal") {
    //   setRunTour(false);          // pause while navigating
    //   navigate("/myidmPortal");
    //   setTimeout(() => setRunTour(true), 300); // resume after DOM loads
    // }
    else if ([18].includes(nextIndex) && location.pathname !== "/myidmPortal") {
      setRunTour(false);          // pause while navigating
      navigate("/myidmPortal");
      setTimeout(() => setRunTour(true), 300); // resume after DOM loads
    }else if ([19].includes(nextIndex) && location.pathname !== "/myidmPortal") {
      setRunTour(false);          // pause while navigating
      navigate("/myidmPortal");
      setTimeout(() => setRunTour(true), 300); // resume after DOM loads
    }
    else if ([20].includes(nextIndex) && location.pathname !== "/home") {
      setRunTour(false);          // pause while navigating
      navigate("/home");
      setTimeout(() => setRunTour(true), 300); // resume after DOM loads
    }
    // else if ([22].includes(nextIndex) && location.pathname !== "/single-extension-reactivation") {
    //   setRunTour(false);          // pause while navigating
    //   navigate("/single-extension-reactivation");
    //   setTimeout(() => setRunTour(true), 300); // resume after DOM loads
    // } 

    // else if (nextIndex === 12 && location.pathname !== "/request-new-access") {
    //   setRunTour(false); 
    //   navigate('/request-new-access',{'gpid':gpid})
    //   setTimeout(() => setRunTour(true), 800); 
    // }
     
  }
};


const startTour = () => {
  navigate('/home')
  setStepIndex(0);
  localStorage.setItem('tourStepIndex', '0');
  setJoyrideKey(prev => prev + 1); // force Joyride reset

  const firstTarget = document.querySelector(steps[0].target);
  if (firstTarget) {
    firstTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(() => setRunTour(true), 300);
  } else {
    console.warn('First target not found, retrying...');
    setTimeout(() => setRunTour(true), 500);
  }
};
useEffect(() => {
  const handleStartTour = () => startTour();
  window.addEventListener("startTour", handleStartTour);
  return () => window.removeEventListener("startTour", handleStartTour);
}, [startTour]); // optional dependenc


  if (loading) {
    // showLoader();
    return <div>Loading...</div>;
  }
  // if (userProfile?.preferredLanguage) {
  return (
    <div className="page-wrapper" dir="ltr">

      {runTour && (
      
      <Joyride
        steps={steps}
        key={joyrideKey}
        run={runTour}
        continuous
        stepIndex={stepIndex}       // controlled mode
        showSkipButton
        showProgress
        callback={handleJoyrideCallback}
        disableOverlayClose
        scrollOffset={180}         
        scrollToFirstStep
        disableScrollParentFix
        offsetParentSelector="body"
        locale={{
          back: 'Back',
          close: 'Complete',            // when not continuous, or closing
          last: 'Complete',             // the label on the last step (continuous)
          next: 'Next',
          skip: 'Skip',
        }}
        
        styles={{
        options: {
          zIndex: 100001,
          primaryColor: '#1E88E5',       // primary (Next / Complete) button color
          textColor: '#0D1B2A', 
          fontFamily:"Inter, sans-serif"
        },
        buttonNext: {
          backgroundColor: '#1E88E5',     // blue 600
          color: '#FFFFFF',
          borderRadius: 6,
          boxShadow: 'none',
        },
        buttonClose: {
          color: '#1E88E5',               // close (X) icon/link
        },
        buttonBack: {
          color: '#1E88E5',               // back link
        },
        tooltipContainer: {
          borderRadius: 8,
          fontSize:'15px'
        },
        spotlight: {
          boxShadow: '0 0 0 9999px rgba(0,0,0,0.45)',
        },
        }}

      />

      )}

      {/* <button onClick={starTour}>Start Tour</button>  */}
      <div style={{ display: "flex" }} className="main-container">
        <div
          ref={headerRef}
          style={{
            position: "fixed",
            width: "-webkit-fill-available",
            zIndex: 1000,
          }}
        >
          {window.location.pathname.includes(
            "/public"
          ) ? null : isAuthenticated && // <HeaderPublic />
            userProfile?.preferredLanguage &&
            !window.location.pathname.includes("/public") ? (
            <HeaderView
              isMenuClicked={showMenu}
              sidebarRef={sidebarRef}
              headerRef={headerRef}
              roles={userProfile?.pepappiamcentralroles}
            />
          ) : null}
        </div>
        <div className="sidebar_align" ref={sidebarRef}>
          {window.location.pathname.includes("/public") ||
            (isMobile && !mobileMenu) ? null : isAuthenticated &&
              userProfile?.preferredLanguage &&
              !window.location.pathname.includes("/public") ? (
            <SidebarView
              isMobileMenuOpen={!mobileMenu}
              userProfile={userProfile}
              isManager={userProfile?.isManager}
              roles={userProfile?.pepappiamcentralroles}
              showMenu={showMenu}
              isMobile={isMobile}
            />
          ) : // <SideNavigationLib />
            // <SideNavigationPeacock />
            null}
        </div>
        <div
          className={
            window.location.pathname.includes("/public")
              ? "main-content-public"
              : "main-content"
          }
        >
          <Routes>
            <Route exact path="/" element={<Login />} />
            <Route exact path="/login" element={<Login />} />

            <Route exactpath="/public/logout" element={<LogoutPage />} />
            <Route
              exact
              path="/home"
              element={
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <HomeView roles={userProfile?.pepappiamcentralroles} />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-accounts"
              element={
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <ManageAccounts />
                </PrivateRoute>
              }
            />
            <Route
              path="/change-password"
              element={
                
              userProfile?.systemsStatus?.myidM
              ? (
              <PrivateRoute
              isAuthenticated={isAuthenticated}
              isLanguage={userProfile?.preferredLanguage}
              >
              <Outage outageSystem={'myidM'}/>
              </PrivateRoute>
              )    // redirect when myidM is down
              :
                (
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <ChangePassword />
                </PrivateRoute>
                )
              }
            />
            <Route
              path="/pki-certificates"
              element={
                userProfile?.systemsStatus?.PKI
              ? (
              <PrivateRoute
              isAuthenticated={isAuthenticated}
              isLanguage={userProfile?.preferredLanguage}
              >
              <Outage outageSystem={'PKI'}/>
              </PrivateRoute>
              )    // redirect when myidM is down
              :
              (
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <ChartsView />
                </PrivateRoute>
              )
              }
            />
            <Route
              path="/myidm"
              element={
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <MyidmView1 roles={userProfile?.pepappiamcentralroles}/>
                </PrivateRoute>
              }
            />
            <Route path="/sso-onboarding" element={<SSOOnboarding />} />
            <Route path="/sso-modification" element={<SSOModification />} />
            <Route path="/sso-onboarding-details" element={<SSOOnboardingDetails />} />
            <Route path="/sso-modification-details" element={<SSOModificationDetails />} />
            <Route
              path="/request-access"
              element={
              (userProfile && userProfile?.pepappiamcentralfeatures && !userProfile?.pepappiamcentralfeatures?.includes('RequestAccess'))
              ? <Navigate to="/home" replace /> // Redirect to home if condition fails
              :
                userProfile && userProfile?.systemsStatus && userProfile?.systemsStatus?.myidM
              ? (
              <PrivateRoute
              isAuthenticated={isAuthenticated}
              isLanguage={userProfile?.preferredLanguage}
              >
              <Outage outageSystem={'myidM'}/>
              </PrivateRoute>
              )    // redirect when myidM is down
              : (
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <SearchRequestsView />
                </PrivateRoute>
              )
              }
            />
            <Route
              path="/request-new-access-others"
              element={
              (userProfile && userProfile?.pepappiamcentralfeatures && !userProfile?.pepappiamcentralfeatures?.includes('RequestAccess'))
              ? <Navigate to="/home" replace /> // Redirect to home if condition fails
              :
                userProfile?.systemsStatus?.myidM
              ? (
              <PrivateRoute
              isAuthenticated={isAuthenticated}
              isLanguage={userProfile?.preferredLanguage}
              >
              <Outage outageSystem={'myidM'}/>
              </PrivateRoute>
              )    // redirect when myidM is down
              :
              (
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  {" "}
                  <RequestNewAccessForOthers />
                </PrivateRoute>
              )
              }
            />
            <Route path="/logincallback" element={<LoginCallBack />} />

            <Route path="/public/logout" element={<LogoutPage />} />
            {/* <Route path="*" element={<Navigate to="/login" />} /> */}
            <Route path="*" element={<Navigate to={isAuthenticated ? "/home" : "/login"} replace />} />
            <Route
              path="/update-profile"
              element={
              (userProfile && userProfile?.pepappiamcentralfeatures && !userProfile?.pepappiamcentralfeatures?.includes('UpdateProfile'))
              ? <Navigate to="/home" replace /> // Redirect to home if condition fails
              :
                userProfile?.systemsStatus?.myidM
              ? (
              <PrivateRoute
              isAuthenticated={isAuthenticated}
              isLanguage={userProfile?.preferredLanguage}
              >
              <Outage outageSystem={'myidM'}/>
              </PrivateRoute>
              )    // redirect when myidM is down
              :
              (
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <UpdateProfile />
                </PrivateRoute>
              )
              }
            />
            <Route
              path="/view-profile"
              element={
              userProfile?.systemsStatus?.myidM
              ? (
              <PrivateRoute
                isAuthenticated={isAuthenticated}
                isLanguage={userProfile?.preferredLanguage}
              >
                <Outage outageSystem={'myidM'}/>
              </PrivateRoute>
              )    // redirect when myidM is down
              :
              (
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <UpdateProfile />
                </PrivateRoute>
              )
              }
            />
            <Route
              path="/update-others-profile"
              element={
              (userProfile && userProfile?.pepappiamcentralfeatures && !userProfile?.pepappiamcentralfeatures?.includes('UpdateProfile'))
              ? <Navigate to="/home" replace /> // Redirect to home if condition fails
              :
                userProfile?.systemsStatus?.myidM
              ? (
              <PrivateRoute
              isAuthenticated={isAuthenticated}
              isLanguage={userProfile?.preferredLanguage}
              >
              <Outage outageSystem={'myidM'}/>
              </PrivateRoute>
              )    // redirect when myidM is down
              :
              (
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <OtherUsersProfileSearch />
                </PrivateRoute>
              )
              }
            />
            <Route
              path="/search-reporting-manager"
              element={
              (userProfile && userProfile?.pepappiamcentralfeatures && !userProfile?.pepappiamcentralfeatures?.includes('UpdateProfile'))
              ? <Navigate to="/home" replace /> // Redirect to home if condition fails
              :
                userProfile?.systemsStatus?.myidM
              ? (
              <PrivateRoute
              isAuthenticated={isAuthenticated}
              isLanguage={userProfile?.preferredLanguage}
              >
              <Outage outageSystem={'myidM'}/>
              </PrivateRoute>
              )    // redirect when myidM is down
              :
              (
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <OtherUsersProfileSearch />
                </PrivateRoute>
              )
              }
            />
            <Route
              path="/myidmPortal"
              element={
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <MyidmView1 roles={userProfile?.pepappiamcentralroles}/>
                </PrivateRoute>
              }
            />
            <Route
              path="/request-new-access"
              element={
              (userProfile && userProfile?.pepappiamcentralfeatures && !userProfile?.pepappiamcentralfeatures?.includes('RequestAccess'))
              ? <Navigate to="/home" replace /> // Redirect to home if condition fails
              :
                userProfile?.systemsStatus?.myidM
              ? (
              <PrivateRoute
              isAuthenticated={isAuthenticated}
              isLanguage={userProfile?.preferredLanguage}
              >
              <Outage outageSystem={'myidM'}/>
              </PrivateRoute>
              )    // redirect when myidM is down
              :
              (
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  {" "}
                  <RequestNewAccessForSelf />
                </PrivateRoute>
              )
              }
            />
            <Route
              path="/single-extension-reactivation"
              element={
              (userProfile && userProfile?.pepappiamcentralfeatures && !userProfile?.pepappiamcentralfeatures?.includes('ContractorReactivation'))
              ? <Navigate to="/home" replace /> // Redirect to home if condition fails
              :
                userProfile?.systemsStatus?.myidM
              ? (
              <PrivateRoute
              isAuthenticated={isAuthenticated}
              isLanguage={userProfile?.preferredLanguage}
              >
              <Outage outageSystem={'myidM'}/>
              </PrivateRoute>
              )    // redirect when myidM is down
              :
              (
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <SingleExtensionReactivation />
                </PrivateRoute>
              )
              }
            />
            <Route
              path="/bulk-revalidation"
              element={
              (userProfile && userProfile?.pepappiamcentralfeatures && !userProfile?.pepappiamcentralfeatures?.includes('ContractorReactivation'))
              ? <Navigate to="/home" replace /> // Redirect to home if condition fails
              :
                userProfile?.systemsStatus?.myidM
              ? (
              <PrivateRoute
              isAuthenticated={isAuthenticated}
              isLanguage={userProfile?.preferredLanguage}
              >
              <Outage outageSystem={'myidM'}/>
              </PrivateRoute>
              )    // redirect when myidM is down
              :
              (
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <BulkRevalidation />
                </PrivateRoute>
              )
              }
            />
            <Route
              path="/extension-request"
              element={
              (userProfile && userProfile?.pepappiamcentralfeatures && !userProfile?.pepappiamcentralfeatures?.includes('ContractorReactivation'))
              ? <Navigate to="/home" replace /> // Redirect to home if condition fails
              :
                userProfile?.systemsStatus?.myidM
              ? (
              <PrivateRoute
              isAuthenticated={isAuthenticated}
              isLanguage={userProfile?.preferredLanguage}
              >
              <Outage outageSystem={'myidM'}/>
              </PrivateRoute>
              )    // redirect when myidM is down
              :
              (
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <ExtensionRequest />
                </PrivateRoute>
              )
              }
            />
            <Route
              path="/audit-requests"
              element={
              (userProfile && userProfile?.pepappiamcentralfeatures && !userProfile?.pepappiamcentralfeatures?.includes('RequestAudit'))
              ? <Navigate to="/home" replace /> // Redirect to home if condition fails
              :
                userProfile?.systemsStatus?.myidM
              ? (
              <PrivateRoute
              isAuthenticated={isAuthenticated}
              isLanguage={userProfile?.preferredLanguage}
              >
              <Outage outageSystem={'myidM'}/>
              </PrivateRoute>
              )    // redirect when myidM is down
              :
               ( 
               <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <PendingAuditRequests />
                </PrivateRoute>
                )
              }
            />
            <Route
              path="/user-audit-requests"
              element={
              (userProfile && userProfile?.pepappiamcentralfeatures && !userProfile?.pepappiamcentralfeatures?.includes('RequestAudit'))
              ? <Navigate to="/home" replace /> // Redirect to home if condition fails
              :
                userProfile?.systemsStatus?.myidM
              ? (
              <PrivateRoute
              isAuthenticated={isAuthenticated}
              isLanguage={userProfile?.preferredLanguage}
              >
              <Outage outageSystem={'myidM'}/>
              </PrivateRoute>
              )    // redirect when myidM is down
              :
              (
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <OtherRequestList />
                </PrivateRoute>
              )
              }
            />
            <Route
              path="/approvals"
              element={
              (userProfile && userProfile?.pepappiamcentralfeatures && !userProfile?.pepappiamcentralfeatures?.includes('Approvals'))
              ? <Navigate to="/home" replace /> // Redirect to home if condition fails
              :
              (
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  {" "}
                  <Approvals />
                </PrivateRoute>
              )
              }
            />
            <Route
              path="/reports"
              element={
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <PowerBIReport />
                </PrivateRoute>
              }
            />
            <Route
              path="/reports_embedded"
              element={
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <PowerBIEmbeddedReport />
                </PrivateRoute>
              }
            />
            <Route exact path="/pam-svc-account" element={<SvcAccountRequest />} />
            <Route
              path="/pam-safe-create-update"
              element={
              (userProfile && userProfile?.pepappiamcentralfeatures && !userProfile?.pepappiamcentralfeatures?.includes('SafeManagement'))
              ? <Navigate to="/home" replace /> // Redirect to home if condition fails
              :
                userProfile?.systemsStatus?.mypam
              ? (
              <PrivateRoute
              isAuthenticated={isAuthenticated}
              isLanguage={userProfile?.preferredLanguage}
              >
              <Outage outageSystem={'mypam'}/>
              </PrivateRoute>
              )    // redirect when myidM is down
              :
              (
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <PamSafeCreateUpdate />
                </PrivateRoute>
              )
              }
            />
            <Route
              path="/pam-safe-access-request"
              element={
              (userProfile && userProfile?.pepappiamcentralfeatures && !userProfile?.pepappiamcentralfeatures?.includes('SafeManagement'))
              ? <Navigate to="/home" replace /> // Redirect to home if condition fails
              :
                userProfile?.systemsStatus?.mypam
              ? (
              <PrivateRoute
              isAuthenticated={isAuthenticated}
              isLanguage={userProfile?.preferredLanguage}
              >
              <Outage outageSystem={'mypam'}/>
              </PrivateRoute>
              )    // redirect when myidM is down
              :
              (
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <PamSafeAccessRequest />
                </PrivateRoute>
              )
              }
            />
            <Route
              path="/idx-bulk-load"
              element={
              (userProfile && userProfile?.pepappiamcentralfeatures && !userProfile?.pepappiamcentralfeatures?.includes('AttributeBulkLoad'))
              ? <Navigate to="/home" replace /> // Redirect to home if condition fails
              :
              userProfile?.systemsStatus?.DS
              ? (
              <PrivateRoute
              isAuthenticated={isAuthenticated}
              isLanguage={userProfile?.preferredLanguage}
              >
              <Outage outageSystem={'mypam'}/>
              </PrivateRoute>
              )    // redirect when myidM is down
              :
              (
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <IdxAttributeBulkLoad />
                </PrivateRoute>
              )
              }
            />
            <Route
              path="/idx-self-service"
              element={
              (userProfile && userProfile?.pepappiamcentralfeatures && !userProfile?.pepappiamcentralfeatures?.includes('SelfReporting'))
              ? <Navigate to="/home" replace /> // Redirect to home if condition fails
              :
              userProfile?.systemsStatus?.DS
              ? (
              <PrivateRoute
              isAuthenticated={isAuthenticated}
              isLanguage={userProfile?.preferredLanguage}
              >
              <Outage outageSystem={'mypam'}/>
              </PrivateRoute>
              )    // redirect when myidM is down
              :
              (
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <IdxReportingSelfService />
                </PrivateRoute>
              )
              }
            />

    <Route
  path="/idx-testid-request-preprod"
  element={
    (userProfile &&
      userProfile?.pepappiamcentralfeatures &&
      !userProfile?.pepappiamcentralfeatures?.includes(
        "IDXTestIDCreation"
      ))
      ? <Navigate to="/home" replace />
      : (
        <PrivateRoute
          isAuthenticated={isAuthenticated}
          isLanguage={userProfile?.preferredLanguage}
        >
          <IdxTestIdRequestPreProd />
        </PrivateRoute>
      )
  }
/>

<Route
  path="/idx-preprod-group-membership"
  element={
   (userProfile &&
userProfile?.pepappiamcentralfeatures &&
!userProfile?.pepappiamcentralfeatures?.includes('IDXGroupMember'))
      ? <Navigate to="/home" replace />
      : (
        <PrivateRoute
          isAuthenticated={isAuthenticated}
          isLanguage={userProfile?.preferredLanguage}
        >
          <IdxPreProdGroupMembership />
        </PrivateRoute>
      )
  }
/>

<Route
  path="/idx-preprod-application-access"
  element={
    (userProfile && userProfile?.pepappiamcentralfeatures && !userProfile?.pepappiamcentralfeatures?.includes('IDXITEAppAccess'))
      ? <Navigate to="/home" replace />
      : userProfile?.systemsStatus?.DS
      ? (
          <PrivateRoute
            isAuthenticated={isAuthenticated}
            isLanguage={userProfile?.preferredLanguage}
          >
            <Outage outageSystem={'mypam'} />
          </PrivateRoute>
        )
      : (
          <PrivateRoute
            isAuthenticated={isAuthenticated}
            isLanguage={userProfile?.preferredLanguage}
          >
            <IdxPreProdApplicationAccess />
          </PrivateRoute>
        )
  }
/>

<Route
  path="/idx-preprod-password-reset"
  element={
    (userProfile && userProfile?.pepappiamcentralfeatures && !userProfile?.pepappiamcentralfeatures?.includes('IDXITEPasswordReset'))
      ? <Navigate to="/home" replace />
      : userProfile?.systemsStatus?.DS
      ? (
          <PrivateRoute
            isAuthenticated={isAuthenticated}
            isLanguage={userProfile?.preferredLanguage}
          >
            <Outage outageSystem={'mypam'} />
          </PrivateRoute>
        )
      : (
          <PrivateRoute
            isAuthenticated={isAuthenticated}
            isLanguage={userProfile?.preferredLanguage}
          >
            <IdxPasswordReset />
          </PrivateRoute>
        )
  }
/>

            <Route
              path="/ir-suspend-service-account"
              element={
              (userProfile && !userProfile?.isIREnabled)
              ? <Navigate to="/home" replace /> // Redirect to home if condition fails
              :
                userProfile?.systemsStatus?.myidM
              ? (
              <PrivateRoute
              isAuthenticated={isAuthenticated}
              isLanguage={userProfile?.preferredLanguage}
              >
              <Outage outageSystem={'myidM'}/>
              </PrivateRoute>
              )    // redirect when myidM is down
              :
              (
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <IrIncidentResponse />
                </PrivateRoute>
              )
              }
            />
            <Route exact path="/pam-svc-account-approval" element={<SvcAccountRequestApproval />} />
            <Route exact path="/app-retirement" element={<AppRetirement />} />
            <Route exact path="/app-registration" element={
              (userProfile && userProfile?.pepappiamcentralfeatures && !userProfile?.pepappiamcentralfeatures?.includes('EntraAppRegistration'))
              ? <Navigate to="/home" replace /> // Redirect to home if condition fails
              :
                userProfile?.systemsStatus?.DS
              ? (
              <PrivateRoute
              isAuthenticated={isAuthenticated}
              isLanguage={userProfile?.preferredLanguage}
              >
              <Outage outageSystem={'mypam'}/>
              </PrivateRoute>
              )    // redirect when myidM is down
              :
              (
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <AppRegisteration />
                </PrivateRoute>
              )
              } />
            <Route exact path="/active-directory" element={
              (userProfile && userProfile?.pepappiamcentralfeatures && !userProfile?.pepappiamcentralfeatures?.includes('ADDashboard'))
              ? <Navigate to="/home" replace /> // Redirect to home if condition fails
              :
                userProfile?.systemsStatus?.DS
              ? (
              <PrivateRoute
              isAuthenticated={isAuthenticated}
              isLanguage={userProfile?.preferredLanguage}
              >
              <Outage outageSystem={'mypam'}/>
              </PrivateRoute>
              )    // redirect when myidM is down
              :
              (
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <ActiveDirectory />
                </PrivateRoute>
              )
              } />
            <Route exact path="/other-active-directory" element={
              (userProfile && userProfile?.pepappiamcentralfeatures && !userProfile?.pepappiamcentralfeatures?.includes('ADDashboard'))
              ? <Navigate to="/home" replace /> // Redirect to home if condition fails
              :
                userProfile?.systemsStatus?.DS
              ? (
              <PrivateRoute
              isAuthenticated={isAuthenticated}
              isLanguage={userProfile?.preferredLanguage}
              >
              <Outage outageSystem={'mypam'}/>
              </PrivateRoute>
              )    // redirect when myidM is down
              :
              (
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <OtherActiveDirectory />
                </PrivateRoute>
              )
              } />
            <Route
              path="/guest-invitation-request"
              element={
              ((userProfile && userProfile?.pepappiamcentralfeatures && !userProfile?.pepappiamcentralfeatures?.includes('GuestInvitation')) || (userProfile && userProfile?.pepappiamcentralfeatures && !userProfile?.associateType?.toLowerCase()?.includes("employee")))
              ? <Navigate to="/home" replace /> // Redirect to home if condition fails
              :
                userProfile?.systemsStatus?.DS
              ? (
              <PrivateRoute
              isAuthenticated={isAuthenticated}
              isLanguage={userProfile?.preferredLanguage}
              >
              <Outage outageSystem={'mypam'}/>
              </PrivateRoute>
              )    // redirect when myidM is down
              :
              (
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <EntraGuestInvitationRequest />
                </PrivateRoute>
              )
              }
            />
            <Route
              path="/guest-management"
              element={
              ((userProfile && userProfile?.pepappiamcentralfeatures && !userProfile?.pepappiamcentralfeatures?.includes('GuestInvitation')) || (userProfile && userProfile?.pepappiamcentralfeatures && !userProfile?.associateType?.toLowerCase()?.includes("employee")))
              ? <Navigate to="/home" replace /> // Redirect to home if condition fails
              :
                userProfile?.systemsStatus?.DS
              ? (
              <PrivateRoute
              isAuthenticated={isAuthenticated}
              isLanguage={userProfile?.preferredLanguage}
              >
              <Outage outageSystem={'mypam'}/>
              </PrivateRoute>
              )    // redirect when myidM is down
              :
              (
                <PrivateRoute
                  isAuthenticated={isAuthenticated}
                  isLanguage={userProfile?.preferredLanguage}
                >
                  <GuestManagement />
                </PrivateRoute>
              )
              }
            />
            <Route exact path="/workflow-approval" element={<WorkflowApproval />} />
            <Route exact path="/authenticate" element={<><LoginCallback />
              <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9999,
                }}
              >
                <LoadingSpinner
                  className=""
                  size={{
                      height: '50px',
                      width: '50px'
                  }}
                  style={{}}
                />
              </div>
              </>} />
            {/* <Route
              path="*"
              element={
                <Navigate
                  to={isAuthenticated ? window.location.pathname : "/home"}
                />
              }
            /> */}
          </Routes>
        </div>
      </div>
      {(userProfile?.pepappiamcentralroles?.includes("chatBot") || (userProfile?.pepappiamcentralroles && !userProfile?.pepappiamcentralroles?.includes("chatBot") && isAuthenticated)) && (
        // <ChatBotWidget />
        
        <Suspense fallback={<div>Loading ChatBot...</div>}>
        <ChatBot isTimeoutDialogShown={showTimeoutDialog} />
        </Suspense>

        // <ChatBot />
      )}
      {(isAuthenticated && userProfile?.preferredLanguage) ||
        window.location.pathname.includes("/public") ? (
        <Footer />
      ) : null}

      <Modal
        id="actionModal"
        className="Session-expire-modal"
        closeOnOutsideClick={false}
        hideCloseButton={true}
        onCloseModal={closeModal}
        showCloseButton
        showModal={showTimeoutDialog}
        style={{}}
        tertiaryButtonProps=""
        showAuxiliaryButton={false}
        showSecondaryButton={true}
        secondaryButtonProps={{
          onClick: () => {
            showLoader()
            const storedVersion = localStorage.getItem("app_version");
            localStorage.clear();
            localStorage.setItem("logout", "true");
            localStorage.setItem("app_version", storedVersion || "");
            const date = new Date();
            date.setTime(date.getTime() + 60 * 60 * 1000);
            const expires = "expires=" + date.toUTCString();
            document.cookie = "logout= true;" + expires + ";path=/";
            setTimeout(async() => {
                try{
                  await oktaAuth.signOut({
                    postLogoutRedirectUri: REACT_APP_OKTA_POST_LOGOUT_REDIRECTURI,
                  });
                }finally{
                  setTimeout(()=>hideLoader(),1000)
                }
            }, 100);
          },
          size: 'medium',
          text: `Logout (${countdown} sec${countdown !== 1 ? "s" : ""})`,
          variant: 'primary'
        }}
        primaryButtonProps={{
          // onClick: () => { handleLogout(); },
          onClick: () => {
            showLoader()
            const storedVersion = localStorage.getItem("app_version");
            localStorage.clear();
            localStorage.setItem("app_version", storedVersion || "");
            const date = new Date();
            date.setTime(date.getTime() + 60 * 60 * 1000);
            const expires = "expires=" + date.toUTCString();
            document.cookie = "logout= true;" + expires + ";path=/";
            setTimeout(async() => {
              try{
                oktaAuth.signOut({
                  postLogoutRedirectUri: REACT_APP_OKTA_HOST_URL,
                });
              }finally{
                setTimeout(()=>hideLoader(),1000)
              }
            }, 300);
          },
          size: 'medium',
          text: 'Continue',
          variant: 'secondary'
        }}
        title="Session Timeout"
        titleIcon=""
        text={"Your session has expired. Please re-authenticate to continue."}
        // content={
        //   <div>
        //     <p>Your session is about to expire due to inactivity.</p>
        //     {/* <p>Do you want to stay logged in?</p> */}
        //   </div>
        // }
      />
    </div>
  );
  // }
};

function App() {
  useEffect(() => {
    
    const handleResize = () => { };

    window.addEventListener("resize", handleResize);

    const handleClick = (event) => {
      if ((event.target.classList.contains('menu-list-item-text') || event.target.classList.contains('menu-list-item-row')) && !event.target.closest('.filter-dropdown-container')) { 
        const parentMenu = event.target.closest('.menu-list'); 
        if (parentMenu) { 
          parentMenu.style.display = 'none';
        } 
      } 
    }
    document.addEventListener('click',handleClick, true);


    return () => {
      window.removeEventListener("resize", handleResize);
      document.addEventListener("click", handleClick, true);
    };
  }, []);

  const { t, i18n } = useTranslation();

  useEffect(()=>{
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "attributes" && (mutation.attributeName === "data-lang" || mutation.attributeName === "data-route")) {
          const rowsPerPageSpans = document.querySelectorAll('.datatable .advanced-pagination > .controls span')?.[0];
          const pageSpan = document.querySelectorAll('.datatable .advanced-pagination > .main-pagination .controls')?.[1];
          if(rowsPerPageSpans){
            rowsPerPageSpans.textContent = t("common_components.data_table_rows_per_page");
          }
          if(pageSpan){
            const page = pageSpan.querySelector('span')
            if(page) page.textContent = t("common_components.data_table_page");
            const of = pageSpan.querySelector(':scope > span:last-child');
            if (of){
              const textNode = Array.from(of.childNodes)
                .find(n => n.nodeType === Node.TEXT_NODE && n.textContent.trim() !== '');
              if (textNode) {
                textNode.nodeValue = t("common_components.data_table_of");
              }
            }
          }
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["data-lang", "data-route"],
    });

    return () => {
      observer.disconnect();
    };
  },[])

  useEffect(() => {
    const handleFocus = (event) => {
      if ((event.target.tagName === "INPUT" && event.target.classList.contains("dropdown-parent") && event.target.closest('#pagination')!== null) || (event.target.tagName === "INPUT" && event.target.id === "text-input-00" && event.target.closest('#pagination')!== null)) {
        event.target.setAttribute("readonly", true);
      }
    };
    const inputs = document.querySelectorAll(".datatable #pagination .dropdown-wrapper .dropdown-input-row input.dropdown-parent");
    inputs.forEach((input) => {
      input.setAttribute("readonly", true);
    });

    const PageInputs = document.querySelectorAll(".datatable #pagination .advanced-pagination > .main-pagination input#text-input-00");
    PageInputs.forEach((input) => {
      input.setAttribute("readonly", true);
    });

    document.addEventListener("focusin", handleFocus);

    return () => {
      document.removeEventListener("focusin", handleFocus);
    };
  }, []);

  // const {
  //   REACT_APP_CLIENT_ID,
  //   REACT_APP_ISSUER,
  //   REACT_APP_REDIRECT_URI,
  //   REACT_APP_POST_REDIRECT_URI,
  // } = process.env;
  // const clientId = REACT_APP_CLIENT_ID;
  // const issuer = REACT_APP_ISSUER;
  // const redirectUrl = REACT_APP_REDIRECT_URI;
  // const postLogoutUrl = REACT_APP_POST_REDIRECT_URI;
  // const oktaAuth = new OktaAuth({
  //   issuer: issuer,
  //   clientId: clientId,
  //   redirectUri: redirectUrl,
  //   postLogoutRedirectUri: postLogoutUrl,
  //   pkce: true,
  //   onAuthRequired: true,
  //   scopes: ["profile", "email", "openid", "offline_access"],
  // });

  // useEffect(() => {
  //   const lang = localStorage.getItem("lang");
  //   if (lang) {
  //     // i18n.changeLanguage(lang);
  //   }
  // }, []);
  // const restoreOriginalUri = async () => {
  //   window.location.href = window.location.origin + "/home";
  // };

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    // 1) okta originalUri
    let target = originalUri
      ? toRelativeUrl(originalUri, window.location.origin)
      : null;
  
    // 2) sessionStorage fallback (set by CrossAppRedirectHandler)
    const saved = sessionStorage.getItem("crossAppRedirect");
    if ((!target || target === "/") && saved) {
      target = saved;
    }

    // 3) Check for workflow approval token
    const savedWorkflowToken = sessionStorage.getItem('wf_email_token');
    if (savedWorkflowToken) {
      sessionStorage.removeItem('wf_email_token');
      target = `/workflow-approval?token=${encodeURIComponent(savedWorkflowToken)}`;
    }
  
    // 4) last resort: redirect query param (if present)
    if (!target || target === "/") {
      const params = new URLSearchParams(window.location.search);
      let q = params.get("redirect");
      if (q) {
        if (!q.startsWith("/")) q = `/${q}`;
        if (!q.includes("://") && !q.startsWith("//")) target = q;
      }
    }
  
    if (!target || target === "/") target = "/home";
  
    sessionStorage.removeItem("crossAppRedirect");
    window.location.replace(target);
  };
  
function InterceptorInitializer() {
  useHttpInterceptor()
  return null
}

function CrossAppRedirectHandler() {
  const { oktaAuth, authState } = useOktaAuth();
  const location = useLocation();
  const handledRef = useRef(false);

  const STORAGE_KEY = "crossAppRedirect";
  const TTL_MS = 5 * 60 * 1000; // 5 minutes

  const normalize = (p) => {
    if (!p) return null;
    let path = String(p).trim();
    if (!path.startsWith("/")) path = `/${path}`;
    // block open redirects
    if (path.includes("://") || path.startsWith("//")) return null;
    return path;
  };

  const writeTarget = (path) => {
    const normalized = normalize(path);
    if (!normalized) return;
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ path: normalized, ts: Date.now() })
    );
  };

  const readTarget = () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const obj = JSON.parse(raw);
      if (!obj?.path || !obj?.ts) return null;
      if (Date.now() - obj.ts > TTL_MS) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return normalize(obj.path);
    } catch {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
  };

  // ✅ Capture redirect as early as possible (useLayoutEffect if you added it, otherwise useEffect)
  useLayoutEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const r = params.get("redirect");
    if (r) writeTarget(r);
  }, []);

  // ✅ Capture if redirect exists in router location too
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const r = params.get("redirect");
    if (r) writeTarget(r);
  }, [location.search]);

  const isAuthed = !!authState?.isAuthenticated;
  const target = readTarget();

  // ✅ If not authenticated: start Okta redirect once
  useEffect(() => {
    if (!target) return;
    if (!authState) return;
    if (isAuthed) return;
    if (handledRef.current) return;

    handledRef.current = true;
    oktaAuth.setOriginalUri(target);
    oktaAuth.signInWithRedirect();
  }, [target, authState, isAuthed, oktaAuth]);

  // ✅ If authenticated: navigate (but do it through state, not conditional hooks)
  const shouldNavigate = Boolean(target && isAuthed && location.pathname !== target);

  // ✅ Clear stored redirect ONLY after we actually land on it
  useEffect(() => {
    if (target && isAuthed && location.pathname === target) {
      localStorage.removeItem(STORAGE_KEY);
    }
  }, [target, isAuthed, location.pathname]);

  // ✅ Now safe to return conditionally (after all hooks)
  if (shouldNavigate) {
    return <Navigate to={target} replace />;
  }

  return null;
}


  return (
    <BrowserRouter>
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <CrossAppRedirectHandler />
        <SessionTimeoutProvider >
        <InterceptorInitializer />
        <FontSizeProvider>
          <ThemeProvider>
            <MenuProvider>
              {/* <LoadingProvider > */}
              <UserProfileProvider>
                {/* <ReCAPTCHA> */}
                <inactivityHandler />
                <MenuDependentContent />
                <ToastContainer position="bottom-center"
                  icon={({ type }) => {
                    if (type === 'error') return <Icon color="red" icon="error_outline" />;
                    if (type === 'info') return <Icon color="blue" icon="info" />;
                    if (type === 'warning') return <Icon color="orange" icon="warning" />;
                    if (type === 'success') return <Icon color="green" icon="check_circle" />;
                    // return '🔔'; 
                  }} autoClose={10000} hideProgressBar={true} />
                  <SessionTimeoutModal />
                {/* </ReCAPTCHA> */}
              </UserProfileProvider>
              {/* <Settings /> */}
              {/* </LoadingProvider> */}
            </MenuProvider>
          </ThemeProvider>
        </FontSizeProvider>
        </SessionTimeoutProvider>
      </Security>
    </BrowserRouter>
  );
}

export default App;
